<template>
  <ErrorBoundary>
    <Card>
      <div class="card-body text-center">
        <div>
          <h6 class="text-left text-[1.125rem]">
            {{
              eventType === 'GIFT_CARD'
                ? t('product.show.checkout.corporateGiftRequest.giftcardTitle')
                : t('product.show.checkout.corporateGiftRequest.kitTitle')
            }}
          </h6>
          <p class="mt-2 text-left text-sm">
            {{
              eventType === 'GIFT_CARD'
                ? t(
                    'product.show.checkout.corporateGiftRequest.giftcardDescription'
                  )
                : t('product.show.checkout.corporateGiftRequest.kitDescription')
            }}
          </p>
        </div>

        <Button
          variant="outlined"
          class="p-2 py-2.5 w-full mt-4 group flex justify-center"
          data-test-id="corporate-gift-request-button"
          link="https://share-eu1.hsforms.com/1ltkibOaNThaZDN40JuR-yAewif8"
          open-new-tab
          @click="sendCorporateGiftRequestGTMEvent(eventType)"
        >
          <span class="flex justify-center items-center relative gap-1">
            <Gift class="stroke-[1.7]" />
            <span>
              {{ t('product.show.checkout.corporateGiftRequest.contactUs') }}
            </span>
            &gt;
          </span>
        </Button>
      </div>
    </Card>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import { Gift } from 'lucide-vue-next'
import { sendCorporateGiftRequestGTMEvent } from '~/composables/useGtmEvents'
const { eventType } = defineProps<{
  eventType: 'GIFT_CARD' | 'BOX'
}>()
const { t } = useI18n()
</script>
